import AddAllButton from 'components/ProductPage/PdpBundling/BundleWidget/AddAllButton/AddAllButton';

export default AddAllButton;
